// extracted by mini-css-extract-plugin
export default {"container":"Alert-container","type-error":"Alert-type-error","typeError":"Alert-type-error"};